const InviteConfirmationEmailEnum = {
  Confirmation: 'Confirmation',
  ConfirmationTickets: 'ConfirmationTickets',
  Custom: 'Custom',
};

export default Object.freeze(InviteConfirmationEmailEnum);
